import { Observable } from 'rxjs';
import { map } from 'rxjs/internal/operators';
import { PhotoGalleryDataIF } from '../photo-gallery/photo-gallery-data-if';
import { DocumentManagementService } from '../../services/document-management-service';
import { PhotoId } from '../../classes/photo-id';
import { Photo } from '../../classes/photo';
import { ProNumber } from '../../classes/pronumber';

export class DocumentListImpl implements PhotoGalleryDataIF {
  constructor(private documentManagement: DocumentManagementService) {}

  public canDeletePhoto(): boolean {
    return false;
  }

  public loadPhoto(photoId: PhotoId): Observable<Photo> {
    return this.documentManagement.getShipmentImagedDocuments(photoId);
  }

  public deletePhoto(photoId: PhotoId): Observable<boolean> {
    return new Observable<boolean>();
  }

  public listPhotoIds(proNumber: ProNumber, docTypes: string[]): Observable<PhotoId[]> {
    return this.documentManagement.listDocumentIds(proNumber).pipe(
      map((photoIds: PhotoId[]) => {
        return photoIds?.filter((photoId) => {
          if (docTypes) {
            return docTypes.indexOf(photoId.imageType) >= 0;
          } else {
            return true;
          }
        });
      })
    );
  }
}
